export default {
  getKidById: state => id => state.students.find(student => student.id === id),
  getStudent: state => state.student,
};
